/* eslint-disable no-unused-vars */
import { useState, useEffect, useMemo } from "react";
import { styled } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import InputBase from "@mui/material/InputBase";
import useTailwindBrand from "../../Theme/useTailwindBrand";
import { FormControl, FormHelperText, InputLabel } from "@mui/material";

const TeachrInput = styled(InputBase, {
  shouldForwardProp: (prop) => prop !== 'notched',
})(() => ({
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: 'transparent',
    border: "none",
    padding: "0",
  },
}));

interface PropsFormMultiSelect {
  defaultValue: number | number[] | string | string[],
  callback: (value: number[]) => void,
  customClass?: string
  label?: string
  placeholders?: string
  placeholder?: string
  data: string[],
  required?: boolean,
  error?: string | undefined
  multiple?: boolean
}

function FormMultiSelect(props: PropsFormMultiSelect) {
  const { classes, brandConfig } = useTailwindBrand()
  
  // Convertir defaultValue en tableau de strings pour le Select
  const initialValues = useMemo((): string[] => {
    if (!props.defaultValue) return [];
    if (Array.isArray(props.defaultValue)) {
      return props.defaultValue.map(v => String(v));
    }
    return [String(props.defaultValue)];
  }, [props.defaultValue]);

  const [values, setValue] = useState<string[]>(initialValues);

  useEffect(() => {
    // Synchroniser avec les changements de defaultValue
    setValue(initialValues);
  }, [initialValues]);

  const handleChange = (event: SelectChangeEvent<typeof values>) => {
    const {
      target: { value },
    } = event;
    const newValues = typeof value === 'string' ? value.split(',') : value;
    setValue(newValues);
    
    // Convertir les strings en nombres et appeler le callback
    const numericValues = newValues
      .map(v => parseInt(v, 10))
      .filter(v => !isNaN(v));
    props?.callback(numericValues);
  };



  return (
    <div>
      <div>
        <FormControl variant="filled" fullWidth >
          <InputLabel required={props.required} className={`${classes.fontFamily} ${props.error ? classes.error : classes.text} font-semibold`}>{props.label}</InputLabel>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={values}
            onChange={handleChange}
            className={`${classes.fontFamily} ${props.error ? classes.errorBorder + ' border-l-4' : 'border-gray-400'} bg-white rounded-md border `}
            // input={<TeachrInput />}
            renderValue={(selected) => {
              // if (selected.length === 0) {
              //   return <span className={`text-slate-400 ${classes.fontFamily}`}>{props?.placeholder || 'Sélectionner...'}</span>;
              // }
              return selected.map(val => {
                const index = parseInt(val, 10) - 1;
                return props?.data[index] || val;
              }).join(', ');
            }}
            displayEmpty
          >
            {props?.data.map((el: string, key: number) => (
              <MenuItem
                sx={{
                  '&.MuiMenuItem-root': {
                    fontFamily: brandConfig.fontFamily
                  }
                }} key={key} value={String(key + 1)}>{el}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormHelperText className={`${classes.fontFamily} ${classes.error} italic font-semibold`}>{props.error}</FormHelperText>
      </div>
      {/* <div className={`flex flex-col py-2 rounded-md px-3 shadow-[rgba(0,0,0,25%)] ${props?.customClass}`}>
        <label className={`block text-sm font-semibold mb-1 ${props.error ? classes.error : classes.text}`}>
          {props.label}
          {props.required && (
            <span className={`${classes.error} ml-1`} aria-label="required">
              *
            </span>
          )}
        </label>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={values}
          onChange={handleChange}
          input={<TeachrInput />}
          renderValue={(selected) => {
            if (selected.length === 0) {
              return <span className={`text-slate-400 ${classes.fontFamily}`}>{props?.placeholder || 'Sélectionner...'}</span>;
            }
            return selected.map(val => {
              const index = parseInt(val, 10) - 1;
              return props?.data[index] || val;
            }).join(', ');
          }}
          displayEmpty
        >
          {props?.data.map((el: string, key: number) => (
            <MenuItem
              sx={{
                '&.MuiMenuItem-root': {
                  fontFamily: brandConfig.fontFamily
                }
              }} key={key} value={String(key + 1)}>{el}</MenuItem>
          ))}
        </Select>
   
      </div> */}
      {/* <p className={`md:text-sm text-xs mt-1 h-4 ${classes.error} font-medium`}>
        {props.error || null}
      </p> */}
    </div>
  );
}
export default FormMultiSelect;
